import { IRequestEventHandler, CoreApiResponse } from "../common";
import { ContentType } from '../../fetchApiDistributor/contentTypes';
import BaseCoreApiRequest from "../baseCoreApiRequest";
import { INewsChatDTO, INewsChatViewDTO, INewsMakerItemCreateDTO, INewsMakerItemEditDTO, INewsMakerDTO, INewsMakerViewDTO } from '../../coreapi-dto/service/newsChat';


class NewsChatRequest extends BaseCoreApiRequest {

    protected _routePrefix: string
    protected _eventHandler: IRequestEventHandler;
    protected readonly _token: string

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl)
        this._routePrefix = 'RedmineNews'
        this._eventHandler = eventHandler
        this._token = token
    }

    getView(filter: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<INewsMakerViewDTO>>) => void) {
        this.post<IViewWrapper<INewsMakerViewDTO>>(`${this._baseUrl}/${this._routePrefix}/view`, filter, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    getById(idGlobal: string, callback?: (e: CoreApiResponse<INewsMakerDTO>) => void) {
        this.get<INewsMakerDTO>(`${this._baseUrl}/${this._routePrefix}/${idGlobal}`, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    update(idGlobal: string, body: INewsMakerItemEditDTO, callback?: (e: CoreApiResponse<null>) => void) {
        this.put(`${this._baseUrl}/${this._routePrefix}/${idGlobal}`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    create(body: INewsMakerItemCreateDTO, callback: (e: CoreApiResponse<string>) => void) {
        this.post<string>(`${this._baseUrl}/${this._routePrefix}`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }

    deleteById(idGlobal: string, callback: (e: CoreApiResponse<null>) => void) {
        this.delete(`${this._baseUrl}/${this._routePrefix}/${idGlobal}`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e: CoreApiResponse<null>) => {
            if (this._eventHandler) {
                if (e.respType === 'isFailed') {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback(e);
        }
        );
    }

    restore(idGlobal: string, callback: (e: CoreApiResponse<null>) => void) {
        super.patch(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/Restore`, null, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                this._eventHandler.onGetResponse(e)
            }
            callback?.(e);
        })
    }

    upsert(body: INewsMakerItemCreateDTO, callback?: (e: CoreApiResponse<string>) => void) {
        this.post<string>(`${this._baseUrl}/${this._routePrefix}/Upsert`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    getActualNews(callback?: (e: CoreApiResponse<INewsChatViewDTO[]>) => void) {
        this.get<INewsChatViewDTO[]>(`${this._baseUrl}/${this._routePrefix}/ActualNews`, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    getNews(callback?: (e: CoreApiResponse<INewsChatViewDTO[]>) => void) {
        this.get<INewsChatViewDTO[]>(`${this._baseUrl}/${this._routePrefix}`, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    assignToAll(idGlobal: string, callback?: (e: CoreApiResponse<any>) => void) {
        this.post<any>(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/assignToAll`, null,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e) => {
                if (this._eventHandler) {
                    if (e.respType === "isFailed") {
                        this._eventHandler.onGetResponse(e);
                    }
                }
                callback?.(e);
            }
        )
    }
    markNewAsViewed(idGlobal: string, callback?: (e: CoreApiResponse<any>) => void) {
        this.post<any>(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/MarkAsViewed`, null,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e) => {
                if (this._eventHandler) {
                    if (e.respType === "isFailed") {
                        this._eventHandler.onGetResponse(e);
                    }
                }
                callback?.(e);
            }
        )
    }
}

export default NewsChatRequest